import { getSingleTspType } from './getSingleTspType'
import { TspType } from '../model/tsp.types'

export const checkIsGameWithRegions = (
  payee: { features?: { category_web?: string } },
  denominations: Record<string, unknown[]>
): boolean => getSingleTspType(payee) === TspType.GAMES && !denominations.noRegion
